import React from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import type {FunctionComponent, HTMLAttributes} from 'react'
import clsx from 'clsx'
import {EditorsChoiceEyeIcon} from '~/icons/product-page/editors-choice-eye-icon'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'
import {getDomainConfig} from '~/domains'

export interface EditorsChoiceBadgeProps extends HTMLAttributes<HTMLDivElement> {}

export const EditorsChoiceBadge: FunctionComponent<EditorsChoiceBadgeProps> = ({...props}) => {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse

  const translations = getTranslation(language)
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)

  return (
    <div {...props}>
      <div className="flex w-full shrink-0 flex-row items-center gap-1">
        <EditorsChoiceEyeIcon
          className={clsx(
            stylesBydomain.LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE,
            'listpage_badge_editors_choice_icon_stroke',
          )}
        />
        <p
          className={clsx(
            'shrink-0 text-[16px] font-medium',
            stylesBydomain.LISTPAGE_BADGE_EDITORS_CHOICE_TEXT,
            'listpage_badge_editors_choice_text',
          )}
        >
          {translations.Badge.editorsChoice}
        </p>
      </div>
    </div>
  )
}
